/** @jsx jsx */

import React, { ReactElement } from 'react';
import { jsx, css } from '@emotion/core';

import PreloadPage from 'app/developer-v3/components/PreloadPage';
import ErrorPage from 'app/developer-v3/components/ErrorPage';
import VersionNotFoundPage from 'app/developer-v3/components/VersionNotFoundPage';

import type { AppSummary } from 'app/developer-v3/types';

const Styles = {
  root: css`
    flex: 1;
    max-width: 1600px;
  `,
};

type Props = {
  appHasLoaded: boolean;
  appSummary?: AppSummary;
  children: ReactElement;
  params: { id?: string; version?: string };
  hasFailure: boolean;
  isVersionMissing?: boolean;
};

const MainContent = (props: Props) => {
  const {
    appHasLoaded,
    appSummary,
    children,
    hasFailure,
    isVersionMissing,
    params,
  } = props;

  let content: ReactElement = <PreloadPage />;

  if (hasFailure) {
    content = <ErrorPage />;
  } else if (isVersionMissing && params.id && params.version) {
    content = (
      <VersionNotFoundPage
        appId={params.id}
        requestedVersion={params.version}
      />
    );
  } else if (!params.id || !params.version || appHasLoaded) {
    content = React.cloneElement(React.Children.only(children), {
      appSummary,
    });
  }

  return <div css={Styles.root}>{content}</div>;
};

export default MainContent;
